// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3S1Wk","list":"PatternAutocomplete_list__H1o5Z"};